import { Button } from "antd";
import '../FreemanRegistration.css'

const LanguageSelection = ({ onLanguageSelect }) => {
  return (<>
    <div style={{ marginTop: '20px' }} className="title-underline"></div>

    <p className="language-prompt">Select your language preference</p>

    <div className="language-buttons">
      <Button
        className="language-btn"
        onClick={() => onLanguageSelect('en')}
      >
        English
      </Button>
      <Button
        className="language-btn"
        onClick={() => onLanguageSelect('es')}
      >
        Spanish
      </Button>
    </div>
  </>)
}


export default LanguageSelection;